import ErrorPage from './ErrorPage';

const PageNotFound = () => <ErrorPage errorKey="pageNotFound" />;

export default PageNotFound;
